import Article from './Article';
import Model from './Model';

export default class Category implements Model{
    private name:String;
    private articles:Array<Article>;


	constructor($name: String, $articles: Array<Article> = []) {
		this.name = $name;
		this.articles = $articles;
    }
    

    /**
     * Getter $name
     * @return {String}
     */
	public get $name(): String {
		return this.name;
	}

    /**
     * Getter $articles
     * @return {Array<Article>}
     */
	public get $articles(): Array<Article> {
		return this.articles;
	}

    /**
     * Setter $name
     * @param {String} value
     */
	public set $name(value: String) {
		this.name = value;
	}

    /**
     * Setter $articles
     * @param {Array<Article>} value
     */
	public set $articles(value: Array<Article>) {
		this.articles = value;
    }
    
    public addArticle(article:Article) {
        this.$articles.push(article);
    }


}